import { useContext, useEffect, useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import "../SignupScreen.css";
import { Store } from "../Store";
import LoadingBox from "../components/LoadingBox";
import useAxios from "../hooks/useAxios";
import { capitalize, getError, validatePassword } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function BusinessUserScreen({ userId, closeHandler }) {
  const Axios = useAxios();
  const [{ loading, error, loadingUpdate }, dispatch] = useReducer(reducer, {
    loading: true,
    error: "",
  });

  const [name, setName] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formValidated, setFormValidated] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");

  const { state } = useContext(Store);
  const { userInfo } = state;

  useEffect(() => {
    if (userId === "0") {
      setName("");
      setIsAdmin(false);
      setEmail("");
    } else {
      const fetchData = async () => {
        try {
          dispatch({ type: "FETCH_REQUEST" });
          const { data } = await Axios.get(`/api/busers/${userId}`);
          setName(data.name);
          setIsAdmin(data.role === "business_admin");
          setEmail(data.email);
          dispatch({ type: "FETCH_SUCCESS" });
        } catch (err) {
          dispatch({
            type: "FETCH_FAIL",
            payload: getError(err),
          });
        }
      };
      fetchData();
    }
  }, [userId, userInfo]);

  const submitHandler = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setFormValidated(true);

      return;
    }

    if (passwordStrength !== "Şifre güçlü") {
      toast.error("Lütfen daha güçlü bir şifre oluşturunuz!");
      return;
    }

    try {
      dispatch({ type: "UPDATE_REQUEST" });
      userId === "0"
        ? await Axios.post("/api/busers", {
            email,
            name,
            password,
            isAdmin,
          })
        : await Axios.put(`/api/busers/${userId}`, {
            email,
            name,
            password,
            isAdmin,
          });
      closeHandler();
      dispatch({ type: "UPDATE_SUCCESS" });
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  return (
    <div>
      {loadingUpdate && <LoadingBox />}
      <Form onSubmit={submitHandler} noValidate validated={formValidated}>
        <Form.Group className="mb-3">
          <Form.Label>Adı ve Soyadı</Form.Label>
          <Form.Control
            className="signup-form-control"
            onChange={(e) => {
              setName(capitalize(e.target.value));
            }}
            value={name}
            required
            autoFocus
          />
          <Form.Control.Feedback type="invalid">
            Lütfen ad alanini boş bırakmayınız
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>E-posta Adresi</Form.Label>
          <Form.Control
            className="signup-form-control"
            autoComplete="off"
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
            name="sdfsflsfslfsdfjlskdjf"
          />
          <Form.Control.Feedback type="invalid">
            Lütfen geçerli bir e-posta adresi giriniz
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Şifre</Form.Label>
          <Form.Control
            className="signup-form-control"
            type="password"
            required
            value={password}
            onChange={(e) => {
              const newPassword = e.target.value;
              setPassword(newPassword);
              validatePassword(newPassword, setPasswordStrength);
            }}
          />
          <small
            id="passwordHelpBlock"
            className={`signup-form-text ${
              passwordStrength === "Şifre güçlü"
                ? "text-success"
                : "text-danger"
            }`}
          >
            {passwordStrength}
          </small>
          <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
        </Form.Group>

        <Form.Check
          className="mb-3 text-muted"
          type="checkbox"
          label={
            isAdmin
              ? "Admin yetkilerine sahip!"
              : "Admin yetkilerine sahip degil!"
          }
          checked={isAdmin}
          onChange={(e) => setIsAdmin(e.target.checked)}
        />
        <div className="mb-3">
          <Button
            size="lg"
            type="submit"
            variant="light"
            className="border-primary text-primary me-2"
          >
            {userId === "0" ? "Kaydet" : "Güncelle"}
          </Button>
          <Button
            size="lg"
            variant="light"
            className="border-danger text-danger"
            onClick={closeHandler}
          >
            Vazgeç
          </Button>
        </div>
      </Form>
    </div>
  );
}
